import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { UserRole } from '../types';

interface ProtectedRouteProps {
  children: React.ReactElement;
  allowedRoles?: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { user, loading, passwordChangeRequired } = useAuth();

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If password change is required, redirect to change password page
  // (unless we're already on the change password page)
  if (passwordChangeRequired && !window.location.pathname.includes('/change-password')) {
    return <Navigate to="/change-password" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const demoAdmin = user.role === 'dev' && user.demo_mode && allowedRoles.includes('admin');
    if (!demoAdmin) {
      return <Navigate to={user.role === 'dev' ? '/dev' : '/login'} replace />;
    }
  }

  return children;
};

